// apps/workflow/src/lib/utils.js

/**
 * Utility function to conditionally join class names.
 * Usage: cn('class1', condition && 'class2', 'class3')
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}